var map = {
	"./kungarna-340px.jpg": "c3d5",
	"./kungarna-821px.jpg": "6dd8",
	"./kungarna.jpg": "96e2",
	"./kungarna_fullsize.jpg": "e039",
	"./logo-header-170px.jpg": "b05d",
	"./logo-header-75px.jpg": "511a",
	"./logo-header.png": "c5b4",
	"./logo_fullsize.png": "21fa",
	"./logo_fullsize_cut.png": "db8b",
	"./svg/code.svg": "0e19",
	"./svg/house.svg": "b1ac",
	"./svg/newspaper.svg": "3df5",
	"./svg/people.svg": "6c77",
	"./svg/pil_ner.svg": "a373"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";